<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/plansetting/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="dateDay" label="计划日期">
          <el-date-picker v-model="searchForm.dateDay" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="loadData">
        <el-tab-pane :label="item[1]" :name="item[0]" v-for="(item, index) of Array.from(planTypeMap)"
          :key="index"></el-tab-pane>
      </el-tabs>
      <el-table size="mini" stripe border :data="tableData">
        <!-- <el-table-column min-width="120" label="计划类型" prop="planType">
          <template v-slot="{ row }">
            {{ planTypeMap.get(row.planType) || '--' }}
          </template>
        </el-table-column> -->
        <el-table-column min-width="120" label="计划日期" prop="dateDay"></el-table-column>
        <el-table-column min-width="120" label="计划产能" prop="planNum"></el-table-column>
        <el-table-column min-width="120" label="允许大车数量" prop="vehicleNum"></el-table-column>
        <el-table-column min-width="120" label="生效时间" prop="startTime"></el-table-column>
        <el-table-column min-width="120" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click=" $router.push('/plansetting/detail?dateId=' + row.dateId)">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/plansetting/edit?dateId=' + row.dateId)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.dateId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { planType } from '@/utils/dict'

export default {
  name: 'PlanSetting',
  mixins: [keepAlive],
  data() {
    return {
      activeName: '1',
      planTypeMap: planType,
      tableData: [],
      page: 1,
      total: 0,
      searchForm: {
        dateDay: '' // 计划日期
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    deleteRow(dateId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.deleteDataWlVehicleDate, {
          dateId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDateByPage, {
        ...this.searchForm,
        page: this.page,
        size: 10,
        planType: this.activeName
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    }
  }
}
</script>
<style lang="scss" scoped></style>
